import IPLYearsCarousel from "@/component/IPL/IPLYearsCarousel";
import PurpleCapTable from "@/component/IPL/PurpleCapTable";
import TopPlayerCard from "@/component/IPL/TopPlayerCard";
import { getDataFromSSR } from "@/handlers/client/commonClient";
import dynamic from "next/dynamic";

import {
  apstagBidCallback,
  createApsSlotsRosDesktop,
  createApsSlotsRosMobile,
  requestBiddingFromPWT,
} from "@/utils/ads";

import { useRouter } from "next/router";
import { useContext, useEffect, useState } from "react";
import { MasterConfigContext } from "@/context/MasterConfigContext";
import IPLSponsor from "@/component/IPL/IPLSponser";
const AdSlot300x250 = dynamic(() => import("@/component/Ads/AdSlot300x250"));
const AdSlot728x90 = dynamic(() => import("@/component/Ads/AdSlot728x90"));
const MGIDAAdsScript = dynamic(() => import("@/component/Ads/MGIDAdsScript"));
const HeadTag = dynamic(() => import("@/component/SeoTags/HeadTag"));
const GTMScript = dynamic(() => import("@/component/Ads/GTMScript"));
const Breadcrumb = dynamic(() => import("@/component/Breadcrumb"));
const BreadcrumbSchema = dynamic(() =>
  import("@/component/SeoTags/BreadcrumbSchema")
);
const ItemsList = dynamic(() => import("@/component/SeoTags/ItemsList"));
const WebpageSchema = dynamic(() =>
  import("@/component/SeoTags/WebpageSchema")
);
// const WebsiteSchema = dynamic(() =>
//   import("@/component/SeoTags/WebsiteSchema")
// );
// const IPLFAQSchema = dynamic(() => import("@/component/SeoTags/IPLFAQSchema"));
const IPLMenu = dynamic(() => import("@/component/IPL/IPLMenu"));
const IPLCommonFooter = dynamic(() =>
  import("@/component/IPL/IPLCommonFooter")
);

const PurpleCapPage = ({
  categoryNewsListData = null,
  isMobileDevice = false,
  faqData = null,
  year = 2025,

  statsData = null,
}) => {
  const iplYearsFilter = {
    2025: "8307",
    2024: "5970",
    2023: "5157",
    2022: "4623",
    2021: "4165",
    2020: "3978",
    2019: "3130",
    2018: "2940",
  };
  const bowlingFilter = [
    "Most Wickets",
    "Most 5-Wicket Haul",
    "Best Economy Rates",
    "Best Bowling Strike Rate",
    "Best Bowling Average",
  ];

  const [selectedYear, setSelectedYear] = useState(year);
  const [tourId, setTourId] = useState(iplYearsFilter[selectedYear || year]);
  const [readMore, setReadMore] = useState(true);
  const handleSelectYear = (year) => {
    setSelectedYear(year);
  };
  const [selectedBowlingFilter, setBowlingFilter] = useState(bowlingFilter[0]);
  const handleBowlingDropdownChange = (e) => {
    setBowlingFilter(e.target.value);
  };

  const [statData, setStatData] = useState([]);
  const [searchByName, setSearchByName] = useState("");

  useEffect(() => {
    const getStatsData = async () => {
      const websiteUrl = process.env.NEXT_PUBLIC_WEBSITE_URL;
      let data = await getDataFromSSR(
        `${websiteUrl}/api/getStatsAPI?tourID=${tourId}&statsId=13`
      );

      const newLeaderboard = data?.data?.data?.leaderboard || [];
      setStatData(newLeaderboard);
    };

    getStatsData();
  }, [year, tourId]);

  useEffect(() => {
    if (!statsData) return;

    const fullLeaderboard = statsData?.leaderboard || [];

    setStatData(
      searchByName
        ? fullLeaderboard.filter((value) =>
            value.player_name.toLowerCase().includes(searchByName.toLowerCase())
          )
        : fullLeaderboard
    );
  }, [searchByName, statsData]);
  // ads implement
  const router = useRouter();
  const currentPath = router?.asPath?.split("?")[0];
  const keyBindings = {
    Category:
      currentPath.split("/").length > 2
        ? [currentPath.split("/")[1], currentPath.split("/")[2]]
        : currentPath.split("/")[1],
    Keywords: categoryNewsListData?.seo_detail?.meta_keyword.split(","),
  };
  const [scrolled, setScrolled] = useState(true);
  // useEffect(() => {
  //   async function onFirstScroll() {
  //     if (!scrolled) {
  //       setScrolled(true);
  //     }
  //   }

  //   function handleScroll() {
  //     onFirstScroll();

  //     window.removeEventListener("scroll", handleScroll);
  //   }

  //   window.addEventListener("scroll", handleScroll);
  // }, []);
  // ads

  useEffect(() => {
    setTimeout(() => {
      window.googletag = window.googletag || { cmd: [] };

      if (window.screen.width < 900) {
        googletag.cmd.push(function () {
          if (scrolled) {
            googletag.destroySlots();
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_ATF_300x250",
                [300, 250],
                "div-gpt-ad-1659434453897-0"
              )
              .addService(googletag.pubads());
          }

          if (scrolled) {
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_MTF_1_300x250",
                [300, 250],
                "div-gpt-ad-1659434604998-0"
              )
              .addService(googletag.pubads());

            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_MTF-2_300x250",
                [300, 250],
                "div-gpt-ad-1659434785315-0"
              )
              .addService(googletag.pubads());

            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_BTF_300x250",
                [300, 250],
                "div-gpt-ad-1659435474737-0"
              )
              .addService(googletag.pubads());
          }
          if (scrolled) {
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_Bottom_320x50",
                [320, 50],
                "div-gpt-ad-1659435612077-0"
              )
              .addService(googletag.pubads());
          }

          // googletag.pubads().enableSingleRequest();
          googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
          Object.keys(keyBindings).forEach((key) => {
            googletag.pubads().setTargeting(key, keyBindings[key]);
          });
          scrolled &&
            googletag?.cmd.push(function () {
              var INTERSTITIALAd = googletag
                ?.defineOutOfPageSlot(
                  "/1007232/News_tak_Mobile_HP_Mweb_Interstitial",
                  googletag?.enums.OutOfPageFormat.INTERSTITIAL
                )
                ?.addService(googletag.pubads());
              INTERSTITIALAd && googletag?.display(INTERSTITIALAd);
            });
        });
      } else {
        googletag.cmd.push(function () {
          if (scrolled) {
            googletag.destroySlots();
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_ATF_728x90",
                [728, 90],
                "div-gpt-ad-1659424515060-0"
              )
              .addService(googletag.pubads());
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_ATF_300x250",
                [300, 250],
                "div-gpt-ad-1707804176041-1"
              )
              .addService(googletag.pubads());
          }
          if (scrolled) {
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_MTF_1_728x90",
                [728, 90],
                "div-gpt-ad-1707804176041-2"
              )
              .addService(googletag.pubads());
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_MTF_2_728x90",
                [728, 90],
                "div-gpt-ad-1707804176041-3"
              )
              ?.addService(googletag.pubads());
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_BTF_728x90",
                [728, 90],
                "div-gpt-ad-1659425743360-0"
              )
              .addService(googletag.pubads());
          }
          // googletag.pubads().enableSingleRequest();
          googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
          Object.keys(keyBindings).forEach((key) => {
            googletag.pubads().setTargeting(key, keyBindings[key]);
          });
        });
      }
      if (scrolled) {
        apstag?.fetchBids(
          {
            slots:
              window.screen.width < 900
                ? createApsSlotsRosMobile({ mtf2: false, mtf3: false })
                : createApsSlotsRosDesktop({ mtf2: false, mtf3: false }),
            timeout: 2e3,
          },
          apstagBidCallback
        );
      }
    }, 10);
  }, [scrolled]);
  const masterConfig = useContext(MasterConfigContext);
  const iplKeys = masterConfig["ipl_2025"];

  const title =
    year == 2025
      ? "IPL 2025 Purple Cap: Most Wickets Takers & Top Bowlers List – NewsTak"
      : `Purple Cap Winner IPL ${year}: ${statData[0]?.player_name}, Highest Wicket-Taker for ${statData[0]?.team_short_name} – NewsTak`;
  const description =
    year == 2025
      ? "Check IPL 2025 Purple Cap standings with most wicket-takers, leading bowlers, updated stats & rankings after every match. Who’s leading the race?"
      : `Who won the Purple Cap in IPL ${year}? ${statData[0]?.player_name} from ${statData[0]?.team_name} wins the Purple Cap in IPL ${year} for taking the most wickets. View full bowling stats, match-wise performance & runner-ups list.`;
  const keywords =
    year == 2025
      ? "IPL 2025 Purple Cap, Purple Cap Winner IPL 2025, Most Wickets in IPL 2025, IPL 2025 Top Bowlers, IPL 2025 Bowling Stats, Purple Cap Holder Today, IPL 2025 Leading Wicket Taker, IPL 2025 Bowler Rankings, IPL 2025 Updated Purple Cap List, IPL Purple Cap List 2025"
      : `Purple Cap Winner IPL ${year}, IPL ${year} Most Wickets, ${statData[0]?.player_name} IPL ${year} Wickets, IPL ${year} Purple Cap Holder, Highest Wicket-Taker IPL ${year}, IPL Purple Cap Stats ${year}, Who won Purple Cap IPL ${year}, IPL ${year} Top Bowlers, IPL Purple Cap List`;
  const canonical =
    year == 2025
      ? "/sports/ipl/purple-cap"
      : `/sports/ipl/purple-cap-winner-${year}`;

  const breadCrumbs = [
    {
      id: "1",
      title: "Sports",
      canonical_url: "/sports",
      amp_url: "",
    },
    {
      id: "2",
      title: "IPL",
      canonical_url: "/sports/ipl",
      amp_url: "",
    },
    {
      id: "3",
      title: "Purple Cap",
      canonical_url: "/sports/ipl/purple-cap",
      amp_url: "",
    },
  ];

  return (
    <div>
      <HeadTag
        title={title}
        description={description}
        keywords={keywords}
        canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + canonical}
        noAuthorTag={false}
        image={categoryNewsListData?.seo_detail?.og_image}
        lcpImage={`${categoryNewsListData?.content?.[0]?.image_small}?size=360:203`}
      />
      <GTMScript isElection={true} />
      {/* <WebsiteSchema /> */}
      {/* <IPLFAQSchema /> */}
      <WebpageSchema
        title={title}
        description={description}
        keywords={keywords}
        canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + canonical}
      />
      <BreadcrumbSchema breadcrumbList={breadCrumbs} />

      <ItemsList
        data={
          categoryNewsListData?.length > 0
            ? [...categoryNewsListData?.content]
            : []
        }
      />
      <Breadcrumb breadcrumbList={breadCrumbs} />
      <MGIDAAdsScript delay={true} />
      <div className="mx-4">
        <AdSlot300x250
          divId="div-gpt-ad-1659434453897-0"
          minWidth="300px"
          minHeight="250px"
        />

        <AdSlot728x90
          divId="div-gpt-ad-1659424515060-0"
          minWidth="728px"
          minHeight="90px"
        />
      </div>

      {iplKeys?.showSponsor && (
        <IPLSponsor color="white" masterConfigKey={iplKeys} />
      )}
      <IPLMenu />
      <section className="mx-4 py-2">
        <h1 className="text-lg font-semibold my-4">
          {year == 2025
            ? "IPL 2025 Purple Cap"
            : `IPL ${year} Purple Cap Winner`}
        </h1>
        {year=="2025"&&<p className={`text-[#323232] text-sm text-left relative inline`}>
          <span className={`${readMore ? "line-clamp-2" : "mb-2"}`}>
            गेंदबाजों को दी जाने वाली यह कैप सभी के बीच चर्चा का विषय बनी रहती
            है. इसको पाने के लिए सभी गेंदबाज मैदान पर कड़ी मेहनत करते हैं. यह
            पर्पल कैप IPL में सबसे ज्यादा विकेट लेने वाले गेंदबाज को दी जाती है.
            इस कैप की खास बात यह है कि ये पूरे टूर्नामेंट के दौरान यह बदलती रहती
            है, जैसे ही कोई नया खिलाडी अधिक विकेट लेता है. यह कैप उसके पास चले
            जाती है. मैच के दौरान केवल वही गेंदबाज इस कैप को पहनकर मैदान में खेल
            सकता है, जिसके सबसे अधिक विकेट होती हैं उसके पास यह कैप टूर्नामेंट
            के अंत में आधिकारिक रूप से चली जाती है. यदि दो खिलाड़ियों के विकेट
            बराबर हों, तो बेहतर इकोनॉमी रेट वाले गेंदबाज को यह कैप दी जाती है.
            इस वर्ष अभी तक इस कैप पर CSK के नूर अहमद ने इसपर अपनी दावेदारी बना
            रखी हैं. भारतीय तेज गेंदबाज भुवनेश्वर कुमार, हर्षल पटेल और
            वेस्टइंडीज के ऑलराउंडर ड्वेन ब्रावो ऐसे खिलाड़ी हैं जिन्होंने दो-दो
            बार यह खिताब जीता है। भारतीय खिलाड़ियों में युजवेंद्र चहल, आरपी
            सिंह, प्रज्ञान ओझा, और मोहित शर्मा ने भी पर्पल कैप हासिल कर चुके
            हैं। विदेशी खिलाड़ियों में पाकिस्तान के सोहेल तनवीर, श्रीलंका के
            लसिथ मलिंगा, ऑस्ट्रेलिया के एंड्रयू टाय और दक्षिण अफ्रीका के मोर्ने
            मोर्कल, इमरान ताहिर और कगिसो रबाडा के पास भी यह पर्पल कैप एक-एक बार
            जा चुकी है.
          </span>
          
            <span
              onClick={() => {
                setReadMore(prev=>!prev);
              }}
              className="cursor-pointer inline -ml-[0.5px]  text-primary text-sm"
            >
              {readMore?"और देखें >":"< कम देखें"}
            </span>
          
        </p>}
        <TopPlayerCard playerData={statData} playerType="purple_cap" />
        <IPLYearsCarousel
          matchData={iplYearsFilter}
          handleSelectYear={handleSelectYear}
          selectedYear={year || selectedYear}
          setTourId={setTourId}
        />
        {scrolled && (
          <div className="my-3">
            <AdSlot300x250
              divId={"div-gpt-ad-1659434604998-0"}
              minWidth="300px"
              minHeight="250px"
            />

            <AdSlot728x90
              divId={"div-gpt-ad-1707804176041-2"}
              minWidth="720px"
              minHeight="90px"
            />
          </div>
        )}

        <h2 className=" mx-3  my-4 font-semibold text-lg">
          IPL {selectedYear} In Numbers
        </h2>
        <div className="flex flex-col sm:flex-row items-center space-y-3 sm:space-y-0 sm:space-x-4 mx-3 my-2">
          {/* Dropdown Filter */}
          <select
            id="battingFilter"
            value={selectedBowlingFilter}
            onChange={handleBowlingDropdownChange}
            className="border rounded p-2 w-full"
          >
            {bowlingFilter?.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>

          {/* Search Input with Icon Inside */}
          <div className="relative w-full">
            <input
              id="search"
              className="placeholder:italic placeholder:text-slate-400 block w-full bg-white border border-slate-300 rounded-md py-2 pl-3 pr-10 shadow-sm focus:outline-none"
              placeholder="Search by Player Name"
              type="text"
              name="search"
              value={searchByName}
              onChange={(e) => setSearchByName(e.target.value)}
            />

            {/* Search Icon Inside Input */}
            <div className="absolute inset-y-0 right-3 flex items-center pointer-events-none">
              <img
                src="/assets/icons/svg/search.svg"
                alt="Search Icon"
                className="w-5 h-5 text-gray-500"
              />
            </div>
          </div>
        </div>

        <PurpleCapTable
          tableContent={statData}
          selectedFilter={selectedBowlingFilter}
          selectedYear={year || selectedYear}
        />
        {scrolled && (
          <div className="my-3">
            <AdSlot300x250
              divId={"div-gpt-ad-1659434785315-0"}
              minWidth="300px"
              minHeight="250px"
            />

            <AdSlot728x90
              divId={"div-gpt-ad-1707804176041-3"}
              minWidth="720px"
              minHeight="90px"
            />
          </div>
        )}
      </section>

      <div className="mx-4">
        <IPLCommonFooter
          categoryNewsListData={categoryNewsListData}
          faqData={faqData}
          isMobileDevice={isMobileDevice}
          showAds={false}
          scrolled={scrolled}
        />
        {scrolled && (
          <AdSlot300x250
            divId={"div-gpt-ad-1659435474737-0"}
            minWidth="300px"
            minHeight="250px"
          />
        )}

        {scrolled && (
          <AdSlot728x90
            divId="div-gpt-ad-1659425743360-0"
            minWidth="720px"
            minHeight="90px"
          />
        )}
      </div>
      <div data-type="_mgwidget" data-widget-id="1584885"></div>
      <script
        async
        dangerouslySetInnerHTML={{
          __html: `window.addEventListener("load", function() {
            (function(w,q){w[q]=w[q]||[];w[q].push(["_mgc.load"])})(window,"_mgq");
          });`,
        }}
      ></script>
    </div>
  );
};

export default PurpleCapPage;
